export default theme => ({
  card: {
    maxWidth: 350
  },
  cardHeader: {
    textAlign: "right",
    marginBottom: "-30px"
  },
  cardContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    minHeight: 190
  },
  cardData: {
    textAlign: "right",
    width: "100%"
  },
  cardInfo: {
    textAlign: "right"
  },
  cardActions: {
    minHeight: 52
  }
});
